import React from "react";
import FormattedNumber from "@/shared/components/FormattedNumber";
import { FlexRow } from "./styledComponents";

function WalletOverview({ totalBalance, virtualTotal, onchainTotal, bankTotal }) {
  return (
    <>
      <h2 style={{ marginBottom: 12 }}>Wallet Overview</h2>

      <FlexRow gap={16} style={{ width: "100%", alignItems: "stretch", marginBottom: 6 }}>
        {/* TOTAL CARD */}
        <div
          style={{
            flex: "1 1 200px",
            padding: "16px",
            borderRadius: "16px",
            background: "linear-gradient(135deg, rgba(0,247,210,0.25), rgba(92,233,255,0.08))",
            border: "1px solid #0f172a",
            boxShadow: "0 0 25px rgba(0,247,210,0.12)",
            backdropFilter: "blur(6px)",
          }}
        >
          <div
            style={{
              fontSize: 12,
              letterSpacing: 0.6,
              color: "#94a3b8",
              textTransform: "uppercase",
            }}
          >
            Total Balance
          </div>
          <div style={{ fontSize: 28, fontWeight: 700, marginTop: 4 }}>
            <FormattedNumber value={totalBalance || 0} symbol="$" maxDecimals={2} />
          </div>
          <div style={{ fontSize: 13, color: "#5ce9ff", marginTop: 4 }}>Upcoming: $ 0.00</div>
          <div
            style={{
              marginTop: 8,
              height: "4px",
              borderRadius: "4px",
              background: "linear-gradient(90deg,#00f7d2,#5ce9ff)",
            }}
          />
        </div>

        {/* VIRTUAL CARD */}
        <div
          style={{
            flex: "1 1 200px",
            padding: "16px",
            borderRadius: "16px",
            background: "linear-gradient(135deg, rgba(0,247,210,0.18), rgba(10,30,55,0.6))",
            border: "1px solid #1f2937",
            boxShadow: "0 0 20px rgba(0,247,210,0.08)",
          }}
        >
          <div
            style={{
              fontSize: 12,
              letterSpacing: 0.6,
              color: "#94a3b8",
              textTransform: "uppercase",
            }}
          >
            Virtual Wallet
          </div>
          <div style={{ fontSize: 22, fontWeight: 600, marginTop: 4 }}>
            <FormattedNumber value={virtualTotal || 0} symbol="$" maxDecimals={2} />
          </div>
          <div style={{ fontSize: 13, color: "#5ce9ff", marginTop: 4 }}>Upcoming: $ 0.00</div>
          <div
            style={{
              marginTop: 8,
              height: "3px",
              borderRadius: "4px",
              background: "linear-gradient(90deg,#00f7d2,#0ea5e9)",
            }}
          />
        </div>

        {/* ON-CHAIN CARD */}
        <div
          style={{
            flex: "1 1 200px",
            padding: "16px",
            borderRadius: "16px",
            background: "linear-gradient(135deg, rgba(92,233,255,0.18), rgba(10,30,55,0.6))",
            border: "1px solid #1f2937",
            boxShadow: "0 0 20px rgba(92,233,255,0.10)",
          }}
        >
          <div
            style={{
              fontSize: 12,
              letterSpacing: 0.6,
              color: "#94a3b8",
              textTransform: "uppercase",
            }}
          >
            On-chain Wallet
          </div>
          <div style={{ fontSize: 22, fontWeight: 600, marginTop: 4 }}>
            <FormattedNumber value={onchainTotal || 0} symbol="$" maxDecimals={2} />
          </div>
          <div style={{ fontSize: 13, color: "#5ce9ff", marginTop: 4 }}>Upcoming: $ 0.00</div>
          <div
            style={{
              marginTop: 8,
              height: "3px",
              borderRadius: "4px",
              background: "linear-gradient(90deg,#5ce9ff,#00f7d2)",
            }}
          />
        </div>

        {/* BANK CARD */}
        <div
          style={{
            flex: "1 1 200px",
            padding: "16px",
            borderRadius: "16px",
            background: "linear-gradient(135deg, rgba(148,163,184,0.18), rgba(10,30,55,0.7))",
            border: "1px solid #1f2937",
            boxShadow: "0 0 20px rgba(148,163,184,0.10)",
          }}
        >
          <div
            style={{
              fontSize: 12,
              letterSpacing: 0.6,
              color: "#94a3b8",
              textTransform: "uppercase",
            }}
          >
            Bank Wallet
          </div>
          <div style={{ fontSize: 22, fontWeight: 600, marginTop: 4 }}>
            <FormattedNumber value={bankTotal || 0} symbol="$" maxDecimals={2} />
          </div>
          <div style={{ fontSize: 13, color: "#5ce9ff", marginTop: 4 }}>Upcoming: $ 0.00</div>
          <div
            style={{
              marginTop: 8,
              height: "3px",
              borderRadius: "4px",
              background: "linear-gradient(90deg,#5ce9ff,#64748b)",
            }}
          />
        </div>
      </FlexRow>
    </>
  );
}

export default WalletOverview;

